import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../../../../theme/types';
import {Column} from '../../common/Layouts/Layouts';
import Image from '@stencil/image';

export const WrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
`,
);

export const ImageStyle = styled(Image)(
  props => `
  width: 100%;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  height: 21rem;
`,
);

export const MiniImageStyle = styled(Image)(
  props => `
  display: flex;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.base};
  height: 4.5rem;
  width: 100%;
`,
);

export const NoImageListIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.goBrandBlue.light};
  width: ${props => props.width || '4.5rem'};
  height: ${props => props.height || '4.5rem'};
  border-radius: ${props => props.theme.misc.borderRadius.base};
`;

export const ImageList = styled.ul(
  props => `
  width: 100%;
  list-style-type: none;
  display: flex;
  position: relative;
  li {
    width: 20%;
    height: 4.5rem;
    border-radius: ${props => props.theme.misc.borderRadius.base};
    margin-right: 0.5rem;
    cursor: pointer;
    background: ${props => (props.isNewListing ? `${props.theme.colors.goBrandBlue.light};` : '')}
    &:last-child{
      margin-right:0;
    }
  }
`,
);

export const ViewAllWrapperStyle = styled.div(
  props => `
  display: flex;
  position: absolute;
  bottom: ${props.theme.spacing.custom(6)};
  right: ${props.theme.spacing.small};
  top: 0rem;
  border-radius: ${props.theme.misc.borderRadius.base};
  width: 18.5%;
  height: 4.5rem;
  align-items: center;
  justify-content: center;
  background-color: ${props.theme.colors.shadow.dark};
  cursor: pointer;
`,
);

export const ViewAllTextStyle = styled.span(
  props => `
  color: ${props.theme.colors.goWhite.base};
  line-height: 1.3;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: ${props.theme.font.custom(10)};
  }
`,
);

export const GoStaysIconWrapperForImageListDiv = styled(Column)`
  background-color: ${props => props.theme.colors.goBrandBlue.base};
  height: 4.5rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
`;

export const GoStaysIconWrapperForImageListSpan = styled.span`
  height: 3.4rem;
  background-color: white;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 0.1rem solid white;
`;

export const ImageStyleFallbackLarge = styled(Image)(
  props => `
  display: flex;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  padding:${props.theme.spacing.xlarge};
`,
);

export const ImageStyleFallbackSmall = styled(Image)(
  props => `
  display: flex;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  padding:${props.theme.spacing.custom(8)};
`,
);
